import { render } from "./MarketingServicesValues.vue?vue&type=template&id=64410a40"
import script from "./MarketingServicesValues.vue?vue&type=script&lang=js"
export * from "./MarketingServicesValues.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__